import { testimonials } from "@/mocks/site";
import { SectionHead } from "./bits";

const principles = [
  {
    icon: "ri-focus-3-line",
    title: "三步核验",
    text: "一看信源是否可追溯，二看材料是否具备原始性与唯一性，三看是否有官方通报或权威佐证。",
  },
  {
    icon: "ri-shield-user-line",
    title: "审慎表述",
    text: "涉及可能构成侵权的对象一律角色化处理，区分“已证实 / 待核实 / 单方说法”，不给读者带节奏。",
  },
  {
    icon: "ri-history-line",
    title: "持续跟进",
    text: "凡进入我们视野的事件，都会以证据时间线持续更新，从预告到实锤落地全程追踪，不烂尾。",
  },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <SectionHead
              eyebrow="About"
              title="关于每日大瓜"
              desc="我们是一支专注娱乐圈资讯整理的轻观察媒体，把顶流塌房预警、法制咖锤与行业潜规则放进可读、可核验的框架里。"
            />
            <p className="-mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              面对铺天盖地的黑料与反转，读者最需要的不是更情绪化的标题，而是一份“谁说了什么、到了哪一步、还差什么佐证”的清晰账本。
              每日大瓜的编辑准则很简单：<strong className="font-medium text-foreground-900">预告可快，但定性要慢</strong>；
              凡是信息未闭环的瓜，我们宁可标成“待核实”，也绝不用标题代替证据。
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-3">
              {principles.map((p) => (
                <div key={p.title} className="rounded-xl border border-background-200 bg-background-50 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-lg text-primary-700">
                    <i className={p.icon} />
                  </span>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{p.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="flex h-full flex-col rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7">
              <h3 className="font-heading text-lg font-bold text-foreground-950">读者怎么说</h3>
              <p className="mt-1 text-xs text-foreground-400">来自站内读者的真实评价摘录</p>
              <div className="mt-5 space-y-4">
                {testimonials.map((t) => (
                  <figure key={t.name} className="rounded-xl border border-background-200 bg-background-100/50 p-4">
                    <div className="flex items-center gap-1 text-accent-500">
                      {[0, 1, 2, 3, 4].map((s) => (
                        <i key={s} className="ri-star-fill text-xs" />
                      ))}
                    </div>
                    <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">
                      “{t.text}”
                    </blockquote>
                    <figcaption className="mt-3 flex items-center gap-2.5">
                      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-600 font-heading text-sm font-bold text-background-50">
                        {t.avatar}
                      </span>
                      <span>
                        <span className="block text-sm font-medium text-foreground-900">{t.name}</span>
                        <span className="block text-xs text-foreground-400">{t.role}</span>
                      </span>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}